import { render } from "./submitSong.vue?vue&type=template&id=5bc81ffb&scoped=true"
import script from "./submitSong.vue?vue&type=script&lang=js"
export * from "./submitSong.vue?vue&type=script&lang=js"

import "./submitSong.vue?vue&type=style&index=0&id=5bc81ffb&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc81ffb"]])

export default __exports__